import { CatButton } from '@blocks-react/components/Button';
import cx from 'classnames';
import { FC, PropsWithChildren } from 'react';
import styles from './LoginButton.module.scss';

interface LoginButtonProps {
  className?: string;
  variant?:
    | 'primary'
    | 'contrast'
    | 'danger'
    | 'ghost'
    | 'ghost-danger'
    | 'inline';
  onClick?: (event: MouseEvent) => void;
  href?: string;
  fullWidth?: boolean;
}

export const LoginButton: FC<PropsWithChildren<LoginButtonProps>> = ({
  children,
  className,
  onClick,
  href,
  fullWidth = true,
  variant = 'primary'
}) => {
  return (
    <CatButton
      className={className}
      fullWidth={fullWidth}
      variant={variant ?? 'primary'}
      onClick={onClick}
      data-testid="login-button"
      href={href}
    >
      <span className={cx(styles['login-button-label'])}>{children}</span>
    </CatButton>
  );
};
